module.exports = __webpack_public_path__ + "shape1.ae011d37cceae760ab31.svg";


//////////////////
// WEBPACK FOOTER
// D:/Projects/Empower360Plus/EmpowerWeb2.0/A4.Empower/A4.Empower/ClientApp/src/assets/images/tooltip/shape1.svg
// module id = ../../../../../src/assets/images/tooltip/shape1.svg
// module chunks = styles